import { useLocation } from 'react-router';
import queryString from 'query-string';
import { useMemo } from 'react';

/**
 * @deprecated
 */
const useQuery = () => {
  const location = useLocation();
  return useMemo(
    () => queryString.parse(location.search, { arrayFormat: 'bracket' }),
    [location]
  );
};

export default useQuery;
